import { injectable } from 'inversify';
import { useContext, useEffect, useMemo, useState } from 'react';
import { Connector, ContainerScope } from '../Container';
import { Physical } from './entities/Physical';
import { ExtendableStore, StateProperty, StatePropertyRef } from './ExtendableStore';
import { OverlayPointerTarget } from './overlay/Overlay';

@injectable()
export class EditorSession extends ExtendableStore {
}

export const inSessionProperties = (...properties: StateProperty<any>[]): Connector =>
    r => void (properties.forEach(x => r.call(EditorSession).extend(x)));

export type EditorTarget = Physical | OverlayPointerTarget;

export const useEditorSessionObserver = <T>(propertyRef: StatePropertyRef<T>) => {
    const container = useContext(ContainerScope);
    const session = container.get(EditorSession);
    const initial = useMemo(() => session.get(propertyRef), [propertyRef]);
    const [value, setValue] = useState(initial);
    useEffect(() => session.observe(propertyRef, setValue), [session]);
    return value;
};
